import { fromJS } from "immutable";

import { ApiListTemplate, UserToken } from "../../../helper/HelperAuth";
import { GetFacebookTemplateData, GlobalLoading } from "../../../store/constants";
import doFetch from "../../../infra/helper/fetchHelper";

export default (page, body) => async (dispatch, getState) => {
    dispatch({ type: GlobalLoading, showLoading: true });
    const Authorization = UserToken;

    const url = ApiListTemplate + "get-facebook-template-data";

    if (page === undefined) {
        page = 1;
    }

    var query = {
        search: body,
        page: page,
        "page-size": 10,
        "order-by": 1,
        order: "DESC",
    };

    var paramBody = {
        query: query,
    };

    const argument = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: Authorization,
        },
        body: JSON.stringify(paramBody),
    };

    const response = await doFetch(url, argument);

    var data = fromJS({});

    if (response.ok) {
        data = fromJS(await response.json());
        var items = [];
        data.get("data").map((item) => {
            items.push({
                "id": item.get("id"),
                "name": item.get("name"),
                "category": item.get("category"),
                "status": item.get("status"),
                "waba-id": item.get("waba-id"),
            });
        });

        var data2 = {
            "row-count": data.get("row-count"),
            "page-size": data.get("rwo-count"),
            "page-count": 1,
            "order-by": data.get("order-by"),
            page: data.get("page"),
            order: data.get("order"),
            data: items,
        };
    }

    dispatch({ type: GlobalLoading, showLoading: false });

    dispatch({ type: GetFacebookTemplateData, data: fromJS(data2) });
};
